import { isInternalTester } from '~/utils/is-internal-tester';

import { SESSION_REPLAY_INTERNAL_TESTER_SAMPLE_RATE, SESSION_REPLAY_SAMPLE_RATE } from '../constants';

function readSegmentUserTraitRecord(user: object): Record<string, unknown> | undefined {
  if (typeof (user as { traits?: unknown }).traits === 'function') {
    const traits = (user as { traits: () => unknown }).traits();
    if (traits !== null && typeof traits === 'object' && !Array.isArray(traits)) {
      return traits as Record<string, unknown>;
    }
  }

  if (typeof (user as { properties?: unknown }).properties === 'function') {
    const properties = (user as { properties: () => unknown }).properties();
    if (properties !== null && typeof properties === 'object' && !Array.isArray(properties)) {
      return properties as Record<string, unknown>;
    }
  }

  return undefined;
}

/**
 * Whether the current Segment user has `is_internal_tester` set from a prior
 * `identify` call. Falls back to `isInternalTester()` when traits are not yet
 * available (e.g. init races ahead of `WithIdentifyAuthedUser`).
 */
export function readIsInternalTesterFromSegmentUser(): boolean {
  if (typeof window === 'undefined' || !window.analytics) return false;

  try {
    const user = typeof window.analytics.user === 'function' ? window.analytics.user() : null;
    if (!user) return isInternalTester();

    const record = readSegmentUserTraitRecord(user);

    if (record && typeof record === 'object' && 'is_internal_tester' in record) {
      return Boolean(record.is_internal_tester);
    }
  } catch {
    return isInternalTester();
  }

  return isInternalTester();
}

/**
 * Session Replay `sampleRate` passed to `@amplitude/session-replay-browser` init.
 * Internal testers are sampled at 100% so we can verify recordings; everyone else
 * uses the default rate.
 */
export function getSessionReplaySampleRate(): number {
  return readIsInternalTesterFromSegmentUser()
    ? SESSION_REPLAY_INTERNAL_TESTER_SAMPLE_RATE
    : SESSION_REPLAY_SAMPLE_RATE;
}
